module.exports = __webpack_public_path__ + "static/media/placeholder.a6165e41.svg";